import { Brand, createBranded } from '@deltasierra/type-utilities';

export type VideoConversionId = Brand<number, 'VideoConversionId'>;
export const VideoConversionId = createBranded<VideoConversionId>();
